import React from "react";
import "./TheParentDashboard.css";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SchoolIcon from "@mui/icons-material/School";
import StarIcon from "@mui/icons-material/Star";
import PersonIcon from "@mui/icons-material/Person";
import CreditScoreIcon from "@mui/icons-material/CreditScore";

export default function StudentBio({ name, grade, school, email, credit, avatar, parent_dashboard_initial_loading }) {
  return (
    <div className="student-bio text-center text-lg-start">
      {!parent_dashboard_initial_loading ?(
        <>
          <div className="row">
            <div className="col-lg-8 px-0">
             <img className="student-avatar mb-2" src={avatar} alt="student" />
            </div>
            <div className="col-lg-4 ">
              <div className="status-badge">Active</div>
            </div>
          </div>
          <div className="student-detail mt-3">
              <p className="student-data"><PersonIcon className="icon" /> {name?name:"N/A"}</p>
              <p className="student-data"><StarIcon className="icon" />Grade {grade?grade:"N/A"}</p>
              <p className="student-data"><SchoolIcon className="icon" /> {school?school:"N/A"}</p>
              <p className="student-data"><MailOutlineIcon className="icon" /> {email?email:"N/A"}</p>
              <p className="student-data"><CreditScoreIcon className="icon" /> Credit availability <span className="credit-pill">{credit?credit:0}</span></p>
          </div>
        </>
      ):(
        <div className="row">Loading....</div>
      )}
     
    </div>
  );
}
